import { LIVE_CALL_STATUSES, type SoftphoneStatus } from "./SoftphoneProvider";

// Why a pre-dial pop-up's call button is disabled, in the user's terms.
// `isReady` is the AND of two independent things — the device being registered
// and no call being live — so the copy has to distinguish "wait a moment" from
// "this needs you". The silent default must be the EXPLANATION, not silence:
// `isReady` is also false during a transport blip and while a fault is deferred
// behind a card, and in both of those the status still reads as something benign.
export const describeUnavailable = (
  status: SoftphoneStatus,
  errorMessage: string | null
): string | null => {
  // A call is live or ringing — the softphone card already says so.
  if (LIVE_CALL_STATUSES.includes(status)) return null;
  if (status === "mic-denied" || status === "error")
    return errorMessage ?? "The voice service is unavailable right now.";
  return "Reconnecting to the voice service — this takes a moment.";
};
